import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { API_BASE_URL } from '@synergy/config';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { BonusSettlementsCustomerOverviewApi } from '../../api/bonus-settlements-customer-overview-api';

const api = new BonusSettlementsCustomerOverviewApi(API_BASE_URL);

export const fetchBonusSettlementsCustomerOverview = createAsyncThunk(
    'bonus-settlements/fetchBonusSettlementsCustomerOverview',
    async (params: { id: number; searchParams: URLSearchParams }, thunkAPI) => {
        const response = await api.getBonusSettlementsCustomerOverview(params.id, params.searchParams);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
            return thunkAPI.rejectWithValue(null);
        }
        return response.result;
    }
);

export const fetchBonusSettlementsCustomerOverviewDetails = createAsyncThunk(
    'bonus-settlements/fetchBonusSettlementsCustomerOverviewDetails',
    async (id: number, thunkAPI) => {
        const response = await api.getBonusSettlementsCustomerOverviewDetails(id);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
            return thunkAPI.rejectWithValue(null);
        }
        return response.result;
    }
);

export const resetBonusSettlementsCustomerOverviewState = createAction(
    'bonus-settlements/resetBonusSettlementsCustomerOverviewState'
);

export const completeCustomers = createAsyncThunk(
    'bonus-settlements/completeCustomers',
    async (
        params: {
            bonusSettlementId: number;
            completeAll?: boolean;
            customerIds?: number[];
        },
        thunkAPI
    ) => {
        const response = await api.postCompleteBonusSettlementCustomers(
            params.bonusSettlementId,
            params.completeAll,
            params.customerIds
        );

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
            return thunkAPI.rejectWithValue(null);
        }

        thunkAPI.dispatch(
            Snackbar.enqueue(
                PoolNotification.success(
                    params.completeAll
                        ? 'app.bonusSettlements.customerOverview.action.completeAll.success'
                        : 'app.bonusSettlements.customerOverview.action.completeCustomer.success'
                )
            )
        );

        return params;
    }
);

export const reloadCustomers = createAsyncThunk(
    'bonus-settlements/reloadCustomers',
    async (
        params: {
            bonusSettlementId: number;
        },
        thunkAPI
    ): Promise<void> => {
        const response = await api.postReloadCustomers(params.bonusSettlementId);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));

            return;
        }

        thunkAPI.dispatch(
            Snackbar.enqueue(PoolNotification.success('app.bonusSettlements.customerOverview.action.reloadAll.success'))
        );
    }
);

export const reloadCustomer = createAsyncThunk(
    'bonus-settlements/reloadCustomer',
    async (
        params: {
            bonusSettlementId: number;
            customerId: number;
        },
        thunkAPI
    ): Promise<void> => {
        const response = await api.postReloadCustomer(params.bonusSettlementId, params.customerId);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));

            return;
        }

        thunkAPI.dispatch(
            Snackbar.enqueue(PoolNotification.success('app.bonusSettlements.customerOverview.action.reload.success'))
        );
    }
);

export const reopenCustomer = createAsyncThunk(
    'bonus-settlements/reopenCustomer',
    async (
        params: {
            bonusSettlementId: number;
            customerId: number;
        },
        thunkAPI
    ) => {
        const response = await api.postReopenBonusSettlementCustomer(params.bonusSettlementId, params.customerId);
        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
            return thunkAPI.rejectWithValue(null);
        }
        return params.customerId;
    }
);
